import { useEffect } from 'react';

const LOCK_ATTRIBUTE = 'data-voyager-lock-scroll';
const LOCK_RULE = 'body[data-voyager-lock-scroll]{touch-action:none;overscroll-behavior:none}';

let lockCount = 0;
let styleElement: HTMLStyleElement | null = null;
let savedHtmlOverflow = '';
let savedBodyPaddingRight = '';

function acquireBodyScrollLock() {
  if (lockCount === 0) {
    const root = document.documentElement;
    savedHtmlOverflow = root.style.overflow;
    savedBodyPaddingRight = document.body.style.paddingRight;

    const scrollbarWidth = window.innerWidth - root.clientWidth;
    root.style.overflow = 'hidden';
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    document.body.setAttribute(LOCK_ATTRIBUTE, '');
    document.head.querySelectorAll(`style[${LOCK_ATTRIBUTE}]`).forEach((stale) => stale.remove());
    styleElement = document.createElement('style');
    styleElement.setAttribute(LOCK_ATTRIBUTE, '');
    styleElement.textContent = LOCK_RULE;
    document.head.appendChild(styleElement);
  }
  lockCount += 1;
}

function restore(style: CSSStyleDeclaration, property: string, previous: string) {
  if (previous) {
    style.setProperty(property, previous);
  } else {
    style.removeProperty(property);
  }
}

function releaseBodyScrollLock() {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    restore(document.documentElement.style, 'overflow', savedHtmlOverflow);
    restore(document.body.style, 'padding-right', savedBodyPaddingRight);
    savedHtmlOverflow = '';
    savedBodyPaddingRight = '';

    document.body.removeAttribute(LOCK_ATTRIBUTE);
    styleElement?.remove();
    styleElement = null;
    document.head.querySelectorAll(`style[${LOCK_ATTRIBUTE}]`).forEach((stale) => stale.remove());
  }
}

export function useLockBodyScroll(locked: boolean) {
  useEffect(() => {
    if (!locked) return;
    acquireBodyScrollLock();
    return releaseBodyScrollLock;
  }, [locked]);
}
